/**
 * Accordion Container: renders our accordion inside an HTML element (div, p, span, ul);
 * HTML block-level elements (for span, make sure to set display to block)
 */

import React, { ReactNode, RefObject } from "react";

interface RendererProps {
  className?: string;
  children: ReactNode;
  ref?: RefObject<HTMLElement | null>;
  nodeName?: ElementNodeName;
}

export type ElementNodeName = "div"|"p"|"span"|"ul"; 
  
export default function AccordionContainer({ className, children, ref, nodeName = "div", ...rest }: RendererProps) {
  return React.createElement(nodeName, { className, ref, ...rest }, children);
}